<template>
  <div class="content">
    <div class="content-select">
      <el-row :gutter="20">
        <el-col :span="4">
          <div class="select-title">
            <div class="title-img">
              <img src="@/assets/appraisal/select-icon.png" alt="">
            </div>
            <div class="title-info">
              <span>案件调查</span>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="content-header">
      <myTableSearch :isOperate="true" :operateWidth="350" :formData="formData" :tableLabel="tableLabel"
                     :isSelection="false"
                     :queryFn="queryFn" :queryParams="queryParams" @successQuery="successQuery" :searchColLg="6"
                     ref="tableRef" dataRow="rows" :rowClassName="tableRowClassName" :tableSelectChange="tableSelectChange">
        <template slot="inquiryStatus" slot-scope="scope">
					<span :style="{ 
						display: 'inline-flex', 
						alignItems: 'center', 
						justifyContent: 'center',
						minWidth: '60px',
						height: '24px',
						padding: '0 12px',
						borderRadius: '4px',
						fontSize: '12px',
						color: '#fff',
						backgroundColor: scope.row.inquiryStatus === 1 ? 'rgb(252, 177, 34)' : 'rgb(32, 201, 128)'
					}">
						{{ scope.row.inquiryStatus==2?'已结案':'调查中' }}
					</span>
        </template>
        <template slot="tool">
          <div class="toolbar-container">
            <div class="toolbar-left">
              <div class="tool-btn" @click="handleRefresh" title="刷新">
                <img :src="refreshIcon" alt="刷新" class="toolbar-icon">
              </div>
            </div>
            <div class="toolbar-right">
              <el-button type="primary" icon="el-icon-fake custom-icon icon-policy-download" @click="handleExportCase" :loading="exportCaseLoading">
                案件导出</el-button>
<!--              <el-button plain type="primary" icon="el-icon-edit" @click="handleBatchEdit">批量修改</el-button>-->
            </div>
          </div>
        </template>
        <template #woundedName="scope">
          <flag :content="scope.row.woundedName" :tip="scope.row.woundedCause" :showTip="scope.row.woundedBlack"></flag>
        </template>
        <template #unitName="scope">
          <flag :content="scope.row.unitName" :tip="scope.row.unitCause" :showTip="scope.row.unitBlack"></flag>
        </template>
        <template #remainingPrompts="scope">
          <span :class="getRemainingPromptTextClass(scope.row)">
            {{ formatRemainingPromptsCell(scope.row) }}
          </span>
        </template>
        <template slot="operate" slot-scope="scope">
          <el-button @click="handleView(scope.row)" size="small" type="text">查看详情</el-button>
          <el-button @click="handleContinueInvestigation(scope.row)" size="small" v-if="scope.row.inquiryStatus == 1" type="text">继续调查</el-button>
<!--          <el-button @click="handleEditCase(scope.row)" size="small" v-if="scope.row.inquiryStatus == 1" type="text">编辑案件</el-button>-->
        </template>
      </myTableSearch>
      <!-- 新增/编辑/查看政策 -->
      <policyDialog v-if="isSubscribeDialog" :isDialog="isSubscribeDialog" :isEdit="isEdit" :isView="isView"
                    :editData="editData"
                    @handleClose="isSubscribeDialog = false" @success="handleRefresh">
      </policyDialog>
      <!-- 导入结果 -->
      <importResultDialog v-if="isImportResultDialog" :isDialog="isImportResultDialog" :resultData="importResultData"
                          @handleClose="isImportResultDialog = false">
      </importResultDialog>
      <addCaseDialog
          ref="addCaseDialogRef"
          :isDialog="isAddCaseDialog"
          :isView="false"
          :editData="editData"
          @handleClose="handleAddCaseDialogClose"
          @submit="handleAddCaseSubmit"
          :type="2"
      />
      <batchEdit ref="batchEditRef" :isDialog="isBatchEditDialog" @handleClose="handleBatchEditClose"></batchEdit>
    </div>
  </div>
</template>

<script>
import {getSurveyPage,exportCase} from '@/api/recognition/survey'
import {getListByDictType} from '@/api/sys/dictData'
import importResultDialog from './components/importResultDialog.vue'
import arrowLeftIcon from '@/assets/pages/appointment/arrow-l.png'
import arrowRightIcon from '@/assets/pages/appointment/arrow-r.png'
import refreshIcon from '@/assets/pages/appointment/refresh.png'
import deleteIcon from '@/assets/pages/appointment/delete.png'
import addIcon from '@/assets/pages/appointment/add.png'
import addCaseDialog from '@/views/pages/recognition/accept/components/addCaseDialog.vue'
import {getAcceptedit, getAcceptDetail} from "@/api/recognition";
import batchEdit from "@/views/pages/recognition/Investigation/index/components/batchEdit.vue";
import flag from "@/components/flag/index.vue";
import {downLoadFile} from "@/utils/downLoad";
export default {
  components: {
    importResultDialog,
    addCaseDialog,
    batchEdit,
    flag
  },
  data() {
    return {
      arrowLeftIcon,
      arrowRightIcon,
      refreshIcon,
      deleteIcon,
      addIcon,
      currentPage: 1,
      downloadTemplateLoading: false,
      importLoading: false,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        pageSizes: [10, 20, 50]
      },
      isSubscribeDialog: false,//新增/编辑预约弹窗
      isEdit: false,//是否为编辑模式
      editData: {},//编辑时的数据
      isImportResultDialog: false,//导入结果弹窗
      importResultData: '',//导入结果
      formData: [
        {
          label: '案件状态',
          type: 'select',
          key: 'inquiryStatus',
          colLg: 6,
          data: []
        },
        {
          label: '受理日期',
          type: 'daterange',
          key: 'appointmentDate',
          colLg: 6,
          screen: (value) => {
            if (value && value.length === 2) {
              return {
                acceptData: value[0],
                subscribeTimeEnd: value[1]
              }
            }
            return {}
          }
        },
        {
          label: '案件编号',
          type: 'input',
          key: 'caseCode',
          colLg: 6,
        }, {
          label: '用人单位',
          type: 'input',
          key: 'unitName',
          colLg: 6,
        },
        // {
        //     label: '伤害类型',
        //     type: 'select',
        //     key: 'injuryType',
        //     colLg: 6,
        //     data: []
        // },

        {
          label: '伤者姓名',
          type: 'input',
          key: 'woundedName',
          colLg: 6,
        },
        {
          label: '承办人',
          type: 'input',
          key: 'acceptUserName',
          colLg: 6,
        }
      ],
      tableLabel: [
        {
          prop: 'caseCode',
          label: '案件编号',
          width: 120
        },
        {
          prop: 'applyDate',
          label: '申请日期',
          width: 120
        },
        {
          prop: 'woundedName',
          label: '伤者姓名',
          minWidth: 200,
          isTooltip:false
        },
        {
          prop: 'unitName',
          label: '用人单位',
          minWidth: 200,
          isTooltip:false
        },
        {
          prop: 'accidentDate',
          label: '事故日期',
          width: 120
        },
        {
          prop: 'acceptUserName',
          label: '承办人'
        },
        {
          prop: 'inquiryStatus',
          label: '案件状态',
          width: 140
        },
        {
          prop: 'remainingPrompts',
          label: '剩余提示',
          width: 140,
          isTooltip: false
        }
      ],
      isAddCaseDialog: false,
      isBatchEditDialog:false,
      batchEditData:[],
      exportCaseLoading:false
    }
  },
  created() {
    this.loadCaseStatusData()
    this.loadInjuryTypeData()
  },
  methods: {
    // 获取列表数据
    queryFn(queryParams) {
      return getSurveyPage(queryParams)
    },
    // 获取案件状态字典
    async loadCaseStatusData() {
      const res = await getListByDictType('industrial_injury_case_status')
      if (res && res.code === 200 && res.data) {
        res.data.unshift({
          dictLabel: '全部',
          dictValue: ''
        })
        this.updateFormDataWithCaseStatus(res.data)
      }
    },
    // 更新案件状态下拉选项
    updateFormDataWithCaseStatus(caseStatusData) {
      if (!caseStatusData) return

      const caseStatusIndex = this.formData.findIndex(item => item.key === 'inquiryStatus')
      if (caseStatusIndex !== -1) {
        this.$set(this.formData[caseStatusIndex], 'data', caseStatusData)
      }
    },

    // 获取伤害类型字典
    async loadInjuryTypeData() {
      const res = await getListByDictType('industrial_injury_harm_type')
      if (res && res.code === 200 && res.data) {
        res.data.unshift({
          dictLabel: '全部',
          dictValue: ''
        })
        this.updateFormDataWithInjuryType(res.data)
      }
    },
    // 更新伤害类型下拉选项
    updateFormDataWithInjuryType(injuryTypeData) {
      if (!injuryTypeData) return
      const injuryTypeIndex = this.formData.findIndex(item => item.key === 'injuryType')
      if (injuryTypeIndex !== -1) {
        this.$set(this.formData[injuryTypeIndex], 'data', injuryTypeData)
      }
    },
    // 上一页
    handlePrevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.queryParams.pageNum = this.currentPage;
        this.$refs.tableRef && this.$refs.tableRef.handleSearch();
      }
    },
    // 下一页
    handleNextPage() {
      this.currentPage++;
      this.queryParams.pageNum = this.currentPage;
      this.$refs.tableRef && this.$refs.tableRef.handleSearch();
    },
    // 刷新列表
    handleRefresh() {
      this.queryParams.pageNum = 1;
      this.currentPage = 1;
      this.$refs.tableRef && this.$refs.tableRef.handleSearch();
    },

    // 下载导入模板
    handleDownloadTemplate() {
      this.downloadTemplateLoading = true
      getSubscribeTemplate().then(res => {
        if (res) {
          this.downloadBlobFile(res, '预约导入模板.xls');
        }
      }).finally(() => {
        this.downloadTemplateLoading = false
      })
    },
    // 导入文件
    handleImportFile(file) {
      const isExcel = file.raw.type === 'application/vnd.ms-excel' ||
          file.raw.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      const isLt10M = file.raw.size / 1024 / 1024 < 10

      if (!isExcel) {
        this.$message.error('只能上传 .xls 或 .xlsx 格式的文件！')
        return
      }
      if (!isLt10M) {
        this.$message.error('文件大小不能超过 10MB！')
        return
      }

      this.importLoading = true
      const formData = new FormData()
      formData.append('file', file.raw)

      importSubscribe(formData).then(res => {
        if (res && res.code === 200) {
          this.importResultData = res.data
          this.isImportResultDialog = true
          this.handleRefresh()
        } else {
          this.$message.error(res.msg || '导入失败')
        }
      }).catch(err => {
        console.error('导入出错', err)
        this.$message.error('导入失败')
      }).finally(() => {
        this.importLoading = false
        this.$refs.uploadRef && this.$refs.uploadRef.clearFiles()
      })
    },
    // 案件导出
    handleExportCase() {
      this.exportCaseLoading = true
      exportCase({...this.queryParams.query}).then(res => {
          if (res) {
            downLoadFile(res,'案件调查',new Date().getTime(),'xls')
          }
      }).finally(() => {
          this.exportCaseLoading = false
      })
    },
    // 查看详情
    handleView(row) {
      this.$router.push({
        path: '/work/Management/detail',
        query: {
          id: row.id,
          type: '1',
          pageType: '1'
        }
      })
    },
    // 继续调查
    handleContinueInvestigation(row) {
      console.log(row, '点击了继续调查')
      this.$router.push({
        path: '/work/Management/detail',
        query: {
          id: row.id,
          type: '2',
          pageType: '1'
        }
      })
    },

    // 更新总数
    successQuery(e) {
      this.syrkNum = e.total;
    },
    handleAddCaseDialogClose() {
      this.isAddCaseDialog = false
    },
    handleBatchEditClose(){
      this.isBatchEditDialog = false
    },
    // 编辑案件
    handleEditCase(row) {
      getAcceptDetail({id: row.id}).then(res => {
        if (res && res?.code === 200 && res.data) {
          this.editData = res.data;
          this.isAddCaseDialog = true
        }
      })
    },
    handleAddCaseSubmit(submitData) {
      submitData.id = this.editData.id
      let api = getAcceptedit(submitData)
      api.then(res => {
        if (res && res.code === 200) {
          this.$message.success('修改案件成功')
          this.handleAddCaseDialogClose()
          this.$refs.addCaseDialogRef && this.$refs.addCaseDialogRef.finishSubmit()
          this.handleRefresh()
        } else {
          this.$message.error('修改案件失败')
          this.$refs.addCaseDialogRef && this.$refs.addCaseDialogRef.failSubmit()
        }
      })
    },
    tableSelectChange(e){
      this.batchEditData = e
    },
    handleBatchEdit(){
      if(this.batchEditData.length === 0){
        this.$message.warning('请选择要操作的案件')
        return
      }
      this.isBatchEditDialog = true;
    },
    /** 文案含「超期」视为已超期，整行 error 样式 */
    isOverdueRemainingPrompt(row) {
      const t = row && row.remainingPrompts
      if (t == null || t === '') return false
      return /超期/.test(String(t))
    },
    /** 剩余天数：优先接口数值 remainingDays，否则从 remainingPrompts 解析「剩余N天」类文案 */
    getRemainingDaysFromRow(row) {
      if (!row) return null
      if (typeof row.remainingDays === 'number' && !Number.isNaN(row.remainingDays)) {
        return row.remainingDays
      }
      const t = row.remainingPrompts
      if (t == null || t === '') return null
      const s = String(t)
      if (/超期/.test(s)) return null
      const m = s.match(/剩余\s*(\d+)\s*天/) || s.match(/还剩\s*(\d+)\s*天/)
      if (m) return parseInt(m[1], 10)
      return null
    },
    /** 行级视觉：超期（danger 红）> ≤15 天（警告黄，压过黑名单行底色）> 黑名单 */
    getRemainingRowVisualState(row) {
      if (this.isOverdueRemainingPrompt(row)) return 'overdue'
      const days = this.getRemainingDaysFromRow(row)
      if (days !== null && days <= 15) return 'warning'
      return null
    },
    formatRemainingPromptsCell(row) {
      const v = row && row.remainingPrompts
      if (v === null || v === undefined || v === '') return '-'
      return v
    },
    getRemainingPromptTextClass(row) {
      if (this.isOverdueRemainingPrompt(row)) {
        return 'remaining-prompt-text remaining-prompt-text--error'
      }
      if (this.getRemainingRowVisualState(row) === 'warning') {
        return 'remaining-prompt-text remaining-prompt-text--warning'
      }
      return ''
    },
    tableRowClassName({ row }) {
      const state = this.getRemainingRowVisualState(row)
      if (state === 'overdue') return 'row-remaining-overdue'
      if (state === 'warning') return 'row-remaining-warning'
      if (row.woundedBlack || row.unitBlack) {
        return 'row-highlight'
      }
    },
  },
}
</script>


<style lang="scss" scoped>
.content {
  width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;

  &-select {
    height: 50px;

    .select-title {
      height: 46px;
      background: url('~@/assets/appraisal/selectBg.png') no-repeat;
      background-size: 100% 100%;
      display: flex;
      align-items: center;
      gap: 12px;
      padding-left: 16px;

      .title-img {
        width: 18px;
        height: 18px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .title-info {
        color: var(--vt-c-black-mute-soft);
        font-size: 16px;
        font-weight: 700;
      }
    }

    .select-serch {
      margin-top: 12px;
      display: flex;
      align-items: center;
      gap: 8px;

      .serch-hint {
        color: var(--vt-c-black-mute-soft);
        font-size: 14px;
        font-weight: 400;
      }

      .serch-info {
        height: 28px;
        display: flex;
        align-items: center;
        gap: 12px;

        .info-item {
          width: 120px;
          height: 28px;
          text-align: center;
          line-height: 28px;
          background: var(--vt-c-blue-mute);
          color: var(--vt-c-blue);
          border-radius: 2px;
          cursor: pointer;
          transition: all 0.3s ease;

          &:hover {
            opacity: 0.8;
          }

          &.active {
            background: var(--vt-c-blue);
            color: var(--vt-c-white);
          }

          &:active:not(.active) {
            transform: scale(0.98);
          }
        }
      }
    }
  }

  &-header {
    margin-top: 16px;
    padding: 0 24px;

    /deep/ .myTableSearch {
      padding: 0;
    }
  }
}

.link-text {
  color: #409eff;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}

.toolbar-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;

  .toolbar-icon {
    width: 24px;
    height: 24px;
  }

  .add-icon {
    width: 20px;
    height: 20px;
    margin-right: 6px;
  }

  .toolbar-left {
    display: flex;
    align-items: center;
    gap: 12px;

    .tool-btn {
      width: 36px;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #dcdfe6;
      cursor: pointer;
      transition: all 0.2s;
      background-color: #FCFCFCFF;
    }

    .list-title {
      font-size: 14px;
      font-weight: 400;
      color: var(--vt-c-blue-soft);
    }
  }

  .toolbar-right {
    display: flex;
    align-items: center;
    gap: 12px;

    .import-upload {
      display: inline-block;

      /deep/ .el-upload {
        display: inline-block;
      }
    }

    .el-button {
      height: 36px;
      padding: 0 16px;
    }
  }
}
.content-header{
  flex: 1;
  display: flex;
  flex-flow: column;
  overflow-y: hidden;
}
/deep/.row-highlight{
  background-color: #d9af891a !important;
  >.el-table__cell:nth-child(1){
    border-left: 4px solid #faad14;
  }
}
/* 剩余≤15 天：警告黄底，与黑名单同时存在时优先于 row-highlight */
/deep/ tr.row-remaining-warning {
  background-color: rgba(250, 173, 20, 0.18) !important;
  > .el-table__cell {
    background-color: rgba(250, 173, 20, 0.18) !important;
  }
  > .el-table__cell:nth-child(1) {
    border-left: 4px solid #e6a23c;
  }
}
/deep/ .el-table__fixed tr.row-remaining-warning > .el-table__cell {
  background-color: rgba(250, 173, 20, 0.18) !important;
}
/* 文案含超期：Element danger 浅红底（与首版一致） */
/deep/ tr.row-remaining-overdue {
  background-color: rgba(245, 108, 108, 0.14) !important;
  > .el-table__cell {
    background-color: rgba(245, 108, 108, 0.14) !important;
  }
  > .el-table__cell:nth-child(1) {
    border-left: 4px solid #f56c6c;
  }
}
.remaining-prompt-text--error {
  color: #f56c6c;
  font-weight: 600;
}
/deep/ tr.row-remaining-overdue .remaining-prompt-text--error {
  color: #f56c6c !important;
}
/deep/ .el-table__fixed tr.row-remaining-overdue > .el-table__cell {
  background-color: rgba(245, 108, 108, 0.14) !important;
}
.remaining-prompt-text--warning {
  color: #e6a23c;
  font-weight: 500;
}
/deep/.el-table__fixed-right{
  background-color: #fff;
}
</style>